/**
 * Analytics module exports
 * Central place to import all analytics functionality
 */

// Event tracking functions
export {
    publishAnalyticsEvent,
    trackComparisonSectionViewed,
    trackAddToCartFromComparison,
    trackAdditionalProductsCustomization,
    trackQuizOpened,
    trackMenuOpened
} from './events.js';

// Import initialization functions for internal use
import { initQuizTracking, triggerQuizTracking } from './quiz-tracking.js';
import { initMenuTracking } from './menu-tracking.js';

// Re-export initialization functions
export { initQuizTracking, triggerQuizTracking, initMenuTracking };

// Legacy filter events (already exists)
// The filter-events.js file is already included in the theme automatically

/**
 * Initialize all analytics tracking
 * Call this function to set up all analytics modules
 */
export function initAnalytics() {
    // Initialize quiz tracking (URL parameter based)
    initQuizTracking();
    
    // Initialize menu tracking
    initMenuTracking();
}

// Export the function that was being used directly
export { initQuizTracking as initUrlBasedTracking };